import React from 'react';

import classNames from 'classnames/bind';
import styles from './NoDataSection.module.scss';

const cx = classNames.bind(styles);

function NoDataSection({ children, areaStyle = null }) {
	return (
		<div
			className={cx('area')}
			style={areaStyle}
		>
			<div className={cx('inner')}>{children}</div>
		</div>
	);
}

export default NoDataSection;
